import {
  Box,
  Button,
  Cards,
  CardsProps,
  Container,
  Header,
  SpaceBetween,
  StatusIndicator
} from '@amzn/awsui-components-react/polaris';
import { useNavigate } from 'react-router-dom';
import { GenAIAgent, AGENT_STATUS_CONFIG } from './GenAIHubTypes';

const GENAI_AGENTS: GenAIAgent[] = [
  {
    id: 'geo-kb',
    name: 'Geo-KB',
    description: 'Get answers based on Geospatial Knowledge Base. Query geospatial concepts, definitions, and documentation using natural language.',
    status: 'prod-ready',
    href: '/geo-kb'
  },
  {
    id: 'road-network-explorer',
    name: 'Road Network Explorer and Analysis Agent',
    description: 'Explore and get snapshots of Road Network data. Query road segments, intersections, and routing information from the Road Segment Model.',
    status: 'experimental',
    href: '/road-network-explorer'
  },
  {
    id: 'map-builder-agent',
    name: 'Map Builder Agent',
    description: 'Get answers around map build, release status and their metrics. Query build pipelines, version information, and deployment status.',
    status: 'experimental',
    href: '/map-builder-agent'
  },
  {
    id: 'tiles-themes-agent',
    name: 'Tiles and Themes Analysis Agent',
    description: 'Analyze and explore tiles metrics and themes datasets. Query tile generation statistics, theme configurations, and visual style data.',
    status: 'experimental',
    href: '/tiles-themes-agent'
  }
];

const AgentCardsContainer = () => {
  const navigate = useNavigate();

  const cardDefinition: CardsProps.CardDefinition<GenAIAgent> = {
    header: (agent) => {
      const statusConfig = AGENT_STATUS_CONFIG[agent.status];
      return (
        <Header
          variant="h2"
          description={
            <StatusIndicator type={statusConfig.type}>
              {statusConfig.label}
            </StatusIndicator>
          }
        >
          {agent.name}
        </Header>
      );
    },
    sections: [
      {
        id: 'description',
        content: (agent) => (
          <Box variant="p" color="text-body-secondary">
            {agent.description}
          </Box>
        )
      },
      {
        id: 'actions',
        content: (agent) => (
          <SpaceBetween direction="horizontal" size="xs">
            {agent.href && (
              <Button
                variant="primary"
                onClick={() => navigate(agent.href!)}
              >
                Launch
              </Button>
            )}
          </SpaceBetween>
        )
      }
    ]
  };

  return (
    <Container
      header={
        <Header
          variant="h2"
          description="Available GenAI agents for Maps Data workflows"
        >
          Agents
        </Header>
      }
    >
      <Cards
        cardDefinition={cardDefinition}
        cardsPerRow={[
          { cards: 1 },
          { minWidth: 500, cards: 2 },
          { minWidth: 992, cards: 3 }
        ]}
        items={GENAI_AGENTS}
        trackBy="id"
      />
    </Container>
  );
};

export default AgentCardsContainer;
